/** Textos Flow IA — ES / EN (contexto por pantalla). */

export const flowIaEs = {
  widgetTitle: 'Flow IA',
  widgetBadge: 'Copiloto Spectra',
  widgetSubtitle: 'Contexto de esta pantalla, prioridades y próximos pasos — con lectura clara y segura.',
  suggestLabel: 'Preguntas sugeridas',
  sectionAnswer: 'Respuesta',
  sectionRecommendations: 'Recomendaciones',
  inputLabel: 'Tu pregunta',
  inputPlaceholder: 'Escribí una pregunta para Flow IA…',
  ask: 'Preguntar',
  soundOn: 'Sonido IA: on',
  soundOff: 'Sonido IA: off',
  soundAria: 'Activar o silenciar sonido suave al consultar Flow IA',
  expand: 'Ver recomendaciones Flow IA',
  collapse: 'Ocultar',
  loading: 'Analizando…',
  errorGeneric: 'No pudimos conectar con el asistente. Mostramos una guía basada en reglas.',
  fallbackAnswer:
    'Flow IA está en modo reglas: revisá los datos visibles en esta pantalla y coordiná con People Ops para priorizar acciones.',
  dash: {
    q1: '¿Qué debería priorizar RRHH hoy?',
    q2: '¿Qué riesgos requieren atención?',
    q3: '¿Qué módulos tienen más pendientes?',
    q4: '¿Qué debería mostrarle a dirección?',
    q5: '¿Qué datos faltan para operar mejor?',
  },
  legajo: {
    q1: '¿Qué documentos están más críticos?',
    q2: '¿Qué colaboradores tienen pendientes?',
    q3: '¿Qué vencimientos debería revisar?',
    q4: '¿Qué conviene automatizar?',
    q5: '¿Cómo mejorar compliance documental?',
  },
  leaves: {
    q1: '¿Qué solicitudes debería aprobar primero?',
    q2: '¿Hay impacto operativo por ausencias?',
    q3: '¿Qué tipos de licencia predominan?',
    q4: '¿Qué revisar antes de aprobar?',
    q5: '¿Qué alertas debería ver RRHH?',
  },
  expenses: {
    q1: '¿Qué gastos requieren revisión?',
    q2: '¿Qué rendiciones podrían ir a Finance?',
    q3: '¿Qué categorías concentran más monto?',
    q4: '¿Qué falta para pagar?',
    q5: '¿Hay gastos rechazables?',
  },
  finance: {
    q1: '¿Cómo puedo mejorar mi salud financiera?',
    q2: '¿Qué categoría debería revisar?',
    q3: '¿Cuánto debería ahorrar este mes?',
    q4: '¿Qué gasto recurrente conviene analizar?',
    q5: '¿Cómo armo un presupuesto 50/30/20?',
  },
  settings: {
    q1: '¿Qué falta antes de cliente real?',
    q2: '¿Qué integraciones están pendientes?',
    q3: '¿Qué permisos conviene revisar?',
    q4: '¿Qué riesgo tiene usar variables demo?',
    q5: '¿Qué debería validar en producción?',
  },
  pi: {
    q1: '¿Cuál es el mayor riesgo actual?',
    q2: '¿Qué acción tendrá más impacto?',
    q3: '¿Qué dimensión está más débil?',
    q4: '¿Qué debería comunicar RRHH?',
    q5: '¿Qué conviene revisar esta semana?',
  },
  portal: {
    q1: '¿Qué trámite conviene hacer primero?',
    q2: '¿Qué documento debería actualizar?',
    q3: '¿Cómo seguir mis licencias?',
    q4: '¿Qué gastos tengo pendientes?',
    q5: '¿Cómo cuidar mi privacidad financiera?',
  },
  employees: {
    q1: '¿Qué colaboradores requieren seguimiento?',
    q2: '¿Qué datos maestros validar?',
    q3: '¿Cómo mejorar cobertura por área?',
    q4: '¿Qué responsables actualizar?',
    q5: '¿Qué exportar para dirección?',
  },
  lifecycle: {
    q1: '¿Qué onboardings están bloqueados?',
    q2: '¿Qué offboardings cerrar primero?',
    q3: '¿Qué checklist falta completar?',
    q4: '¿Qué riesgo legal vigilar?',
    q5: '¿Qué comunicar a managers?',
  },
  orgchart: {
    q1: '¿Qué áreas tienen más colaboradores?',
    q2: '¿Dónde hay vacantes críticas?',
    q3: '¿Qué línea de reporte revisar?',
    q4: '¿Cómo explicar la estructura a dirección?',
    q5: '¿Qué cambios planificar?',
  },
  attendance: {
    q1: '¿Qué ausencias impactan hoy?',
    q2: '¿Qué turnos revisar?',
    q3: '¿Hay tardanzas recurrentes?',
    q4: '¿Qué política reforzar?',
    q5: '¿Qué reporte preparar?',
  },
  communications: {
    q1: '¿Qué comunicado publicar primero?',
    q2: '¿Qué audiencia conviene?',
    q3: '¿Cómo medir lectura?',
    q4: '¿Qué tono usar?',
    q5: '¿Qué recordatorio enviar?',
  },
  notifications: {
    q1: '¿Qué tareas críticas cerrar?',
    q2: '¿Qué vencidas reasignar?',
    q3: '¿Qué alertas de integración hay?',
    q4: '¿Qué priorizar esta semana?',
    q5: '¿Qué preparar antes de go-live?',
  },
  eval: {
    q1: '¿Qué evaluaciones están atrasadas?',
    q2: '¿Qué feedback pedir a managers?',
    q3: '¿Qué competencias revisar?',
    q4: '¿Cómo cerrar el ciclo?',
    q5: '¿Qué calibración hacer?',
  },
  training: {
    q1: '¿Qué cursos vencen primero?',
    q2: '¿Qué cumplimiento regulatorio falta?',
    q3: '¿Qué asignar a nuevos ingresos?',
    q4: '¿Cómo medir avance?',
    q5: '¿Qué recordatorio enviar?',
  },
  climate: {
    q1: '¿Qué encuesta lanzar?',
    q2: '¿Qué dimensión de clima mirar?',
    q3: '¿Cómo subir participación?',
    q4: '¿Qué acción comunicar tras resultados?',
    q5: '¿Qué comparar con el trimestre anterior?',
  },
  awards: {
    q1: '¿Qué reconocimientos destacar?',
    q2: '¿Qué categoría impulsar?',
    q3: '¿Cómo alinear a valores?',
    q4: '¿Qué frecuencia conviene?',
    q5: '¿Qué comunicar en all-hands?',
  },
  reports: {
    q1: '¿Qué reporte abrir primero?',
    q2: '¿Qué KPI llevar a dirección?',
    q3: '¿Qué corte mensual preparar?',
    q4: '¿Qué riesgo documentar?',
    q5: '¿Qué exportación planificar?',
  },
  gen: {
    q1: '¿Qué debería revisar primero en esta pantalla?',
    q2: '¿Qué datos faltan para decidir?',
    q3: '¿Qué acción concreta recomendás?',
    q4: '¿Qué coordinar con managers?',
    q5: '¿Qué validar antes del cierre?',
  },
  settingsPanel: {
    title: 'Flow IA',
    lead:
      'Flow IA entrega recomendaciones contextuales por pantalla. Si la IA real no está activa, el sistema usa respuestas basadas en reglas.',
    stateActive: 'Activo (IA remota)',
    stateFallback: 'Modo reglas / fallback',
    stateDisabled: 'Desactivado en configuración',
    statePending: 'Pendiente API key',
    provider: 'Proveedor configurado',
    model: 'Modelo',
    loading: 'Consultando estado…',
  },
  floating: {
    fabOpen: 'Abrir Flow IA',
    fabDisabled: 'Flow IA no disponible para tu rol',
    contextLabel: 'Pantalla',
    contextGeneric: 'Spectra RRHH',
    intro: 'Preguntá sobre esta pantalla. Las respuestas usan solo el contexto autorizado de tu tenant.',
    inputPlaceholder: 'Escribí tu consulta… (Enter envía, Shift+Enter nueva línea)',
    noPermission: 'Sin permiso ai.use para chatear',
    newChat: 'Nueva conversación',
    close: 'Cerrar asistente',
    cancel: 'Cancelar',
    retry: 'Reintentar',
    sources: 'Fuentes',
    noMutations: 'Flow IA no modifica datos. Cualquier acción futura pedirá confirmación explícita.',
  },
};

export const flowIaEn = {
  widgetTitle: 'Flow IA',
  widgetBadge: 'Spectra copilot',
  widgetSubtitle: 'This screen’s context, priorities, and next steps — clear, safe reading.',
  suggestLabel: 'Suggested questions',
  sectionAnswer: 'Answer',
  sectionRecommendations: 'Recommendations',
  inputLabel: 'Your question',
  inputPlaceholder: 'Ask Flow IA…',
  ask: 'Ask',
  soundOn: 'IA sound: on',
  soundOff: 'IA sound: off',
  soundAria: 'Toggle subtle sound when asking Flow IA',
  expand: 'Show Flow IA recommendations',
  collapse: 'Hide',
  loading: 'Thinking…',
  errorGeneric: 'We could not reach the assistant. Showing a rules-based guide.',
  fallbackAnswer:
    'Flow IA is in rules mode: review the data visible on this screen and align with People Ops on next actions.',
  dash: {
    q1: 'What should HR prioritize today?',
    q2: 'Which risks need attention?',
    q3: 'Which modules have the most open items?',
    q4: 'What should leadership see?',
    q5: 'What data is missing to operate better?',
  },
  legajo: {
    q1: 'Which documents are most critical?',
    q2: 'Which employees have open items?',
    q3: 'Which expiries should I review?',
    q4: 'What is worth automating?',
    q5: 'How to improve document compliance?',
  },
  leaves: {
    q1: 'Which requests should I approve first?',
    q2: 'Is there operational impact from absences?',
    q3: 'Which leave types dominate?',
    q4: 'What to check before approving?',
    q5: 'Which alerts should HR watch?',
  },
  expenses: {
    q1: 'Which expenses need review?',
    q2: 'Which reports could go to Finance?',
    q3: 'Which categories concentrate spend?',
    q4: 'What is missing to pay?',
    q5: 'Any expenses to reject?',
  },
  finance: {
    q1: 'How can I improve my financial health?',
    q2: 'Which category should I review?',
    q3: 'How much should I save this month?',
    q4: 'Which recurring expense should I analyze?',
    q5: 'How do I build a 50/30/20 budget?',
  },
  settings: {
    q1: 'What is missing before a real customer?',
    q2: 'Which integrations are pending?',
    q3: 'Which permissions should we review?',
    q4: 'What risk is there using demo variables?',
    q5: 'What should we validate in production?',
  },
  pi: {
    q1: 'What is the top risk right now?',
    q2: 'Which action has the most impact?',
    q3: 'Which dimension is weakest?',
    q4: 'What should HR communicate?',
    q5: 'What to review this week?',
  },
  portal: {
    q1: 'Which self-service task first?',
    q2: 'Which document should I update?',
    q3: 'How do I track my time off?',
    q4: 'Which expenses are pending?',
    q5: 'How do I protect financial privacy?',
  },
  employees: {
    q1: 'Which employees need follow-up?',
    q2: 'Which master data to validate?',
    q3: 'How to improve coverage by area?',
    q4: 'Which owners to update?',
    q5: 'What to export for leadership?',
  },
  lifecycle: {
    q1: 'Which onboardings are blocked?',
    q2: 'Which offboardings to close first?',
    q3: 'Which checklist items are missing?',
    q4: 'Which legal risk to watch?',
    q5: 'What to tell managers?',
  },
  orgchart: {
    q1: 'Which areas have the most people?',
    q2: 'Where are critical vacancies?',
    q3: 'Which reporting line to review?',
    q4: 'How to explain the structure to executives?',
    q5: 'What changes to plan?',
  },
  attendance: {
    q1: 'Which absences impact today?',
    q2: 'Which shifts to review?',
    q3: 'Any recurring lateness?',
    q4: 'Which policy to reinforce?',
    q5: 'Which report to prepare?',
  },
  communications: {
    q1: 'Which announcement to publish first?',
    q2: 'Which audience fits best?',
    q3: 'How to measure readership?',
    q4: 'Which tone to use?',
    q5: 'Which reminder to send?',
  },
  notifications: {
    q1: 'Which critical tasks to close?',
    q2: 'Which overdue items to reassign?',
    q3: 'Which integration alerts exist?',
    q4: 'What to prioritize this week?',
    q5: 'What to prepare before go-live?',
  },
  eval: {
    q1: 'Which reviews are late?',
    q2: 'Which manager feedback to request?',
    q3: 'Which competencies to review?',
    q4: 'How to close the cycle?',
    q5: 'Which calibration to run?',
  },
  training: {
    q1: 'Which courses expire first?',
    q2: 'Which regulatory training is missing?',
    q3: 'What to assign to new hires?',
    q4: 'How to measure progress?',
    q5: 'Which reminder to send?',
  },
  climate: {
    q1: 'Which survey to launch?',
    q2: 'Which climate dimension to watch?',
    q3: 'How to lift participation?',
    q4: 'What to communicate after results?',
    q5: 'What to compare vs last quarter?',
  },
  awards: {
    q1: 'Which recognitions to highlight?',
    q2: 'Which category to push?',
    q3: 'How to align to values?',
    q4: 'Which cadence makes sense?',
    q5: 'What to share in all-hands?',
  },
  reports: {
    q1: 'Which report to open first?',
    q2: 'Which KPI for leadership?',
    q3: 'Which monthly cut to prepare?',
    q4: 'Which risk to document?',
    q5: 'Which export to plan?',
  },
  gen: {
    q1: 'What should I review first on this screen?',
    q2: 'What data is missing to decide?',
    q3: 'What concrete action do you recommend?',
    q4: 'What to align with managers?',
    q5: 'What to validate before close?',
  },
  settingsPanel: {
    title: 'Flow IA',
    lead:
      'Flow IA gives contextual recommendations per screen. If remote AI is off, the product uses rules-based answers.',
    stateActive: 'Active (remote AI)',
    stateFallback: 'Rules / fallback mode',
    stateDisabled: 'Disabled in configuration',
    statePending: 'Pending API key',
    provider: 'Configured provider',
    model: 'Model',
    loading: 'Loading status…',
  },
  floating: {
    fabOpen: 'Open Flow IA',
    fabDisabled: 'Flow IA not available for your role',
    contextLabel: 'Screen',
    contextGeneric: 'Spectra HR',
    intro: 'Ask about this screen. Answers use only your authorized tenant context.',
    inputPlaceholder: 'Type your question… (Enter sends, Shift+Enter new line)',
    noPermission: 'No ai.use permission to chat',
    newChat: 'New conversation',
    close: 'Close assistant',
    cancel: 'Cancel',
    retry: 'Retry',
    sources: 'Sources',
    noMutations: 'Flow IA does not change data. Any future action will require explicit confirmation.',
  },
};
